import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var paymentUtils = require("../utils/payments");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Payment
 * @static
 * @hideconstructor
 */

/**
 *  Search users
 * @method getById
 * @name Jobin.Payment.getById
 * @param {string} paymentId
 * @returns {Parse.Object}
 */
export function getById(_x) {
  return _getById.apply(this, arguments);
}
/**
 * Get the payments
 * @method getPayments
 * @name Jobin.Payment.getPayments
 * @param {date} startDate
 * @param {date} endDate
 * @param {Array} methodArray
 * @param {Array} typeArray
 * @param {Array} stateArray
 * @param {ParseObject} user
 * @param {string} id
 * @returns {Array} Payments ParseObject array
 */
function _getById() {
  _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(paymentId) {
    var payment;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return new Parse.Query("Payments").get(paymentId);
        case 3:
          payment = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: payment
          });
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", {
            status: "error",
            result: "Fallo al buscar pago"
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _getById.apply(this, arguments);
}
export function getPayments(_x2) {
  return _getPayments.apply(this, arguments);
}
/**
 * Get a user friendly action string
 * @method markAsPaid
 * @name Jobin.Payment.markAsPaid
 * @param {ParseObject} payment
 * @returns {boolean} Success
 */
function _getPayments() {
  _getPayments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
    var startDate, endDate, methodArray, typeArray, stateArray, postalPrefixes, signArray, businessIdArray, user, id, currentUser, query;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          startDate = _ref.startDate, endDate = _ref.endDate, methodArray = _ref.methodArray, typeArray = _ref.typeArray, stateArray = _ref.stateArray, postalPrefixes = _ref.postalPrefixes, signArray = _ref.signArray, businessIdArray = _ref.businessIdArray, user = _ref.user, id = _ref.id;
          _context2.next = 3;
          return Parse.User.currentAsync();
        case 3:
          currentUser = _context2.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context2.next = 20;
            break;
          }
          query = paymentUtils.getPaymentsQuery({
            startDate: startDate,
            endDate: endDate,
            methodArray: methodArray,
            typeArray: typeArray,
            stateArray: stateArray,
            postalPrefixes: postalPrefixes,
            signArray: signArray,
            //[ "positive" | "negative" ]
            businessIdArray: businessIdArray,
            user: user,
            id: id
          });
          query.descending("createdAt");
          _context2.prev = 7;
          _context2.next = 10;
          return query.find();
        case 10:
          _context2.t0 = _context2.sent;
          return _context2.abrupt("return", {
            status: "ok",
            result: _context2.t0
          });
        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2["catch"](7);
          console.error(_context2.t1);
          return _context2.abrupt("return", {
            status: "error",
            result: "Fallo al obtener los pagos."
          });
        case 18:
          _context2.next = 21;
          break;
        case 20:
          return _context2.abrupt("return", {
            status: "error",
            result: "No tienes permisos para realizar esta petición"
          });
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 14]]);
  }));
  return _getPayments.apply(this, arguments);
}
export function markAsPaid(_x3) {
  return _markAsPaid.apply(this, arguments);
}
/**
 * Get a user friendly action string
 * @method changePaymentMethod
 * @name Jobin.Payment.changePaymentMethod
 * @param {ParseObject} payment
 * @param {string} newPaymentMethod
 * @returns {boolean} Success
 */
function _markAsPaid() {
  _markAsPaid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payment) {
    var method, result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          method = payment.get("Method");
          if (!(method === "credit" || method === "business" || method === "funding")) {
            _context3.next = 19;
            break;
          }
          _context3.prev = 2;
          _context3.next = 5;
          return Parse.Cloud.run("markPaymentAsPaid", {
            paymentId: payment.id,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context3.sent;
          if (!result) {
            _context3.next = 10;
            break;
          }
          return _context3.abrupt("return", {
            status: "ok",
            result: true
          });
        case 10:
          return _context3.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de marcar este pago como pagado."
          });
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          console.error(_context3.t0);
          return _context3.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de marcar este pago como pagado."
          });
        case 17:
          _context3.next = 20;
          break;
        case 19:
          return _context3.abrupt("return", {
            status: "error",
            result: "No es posible marcar como pagado este pago."
          });
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 13]]);
  }));
  return _markAsPaid.apply(this, arguments);
}
export function changePaymentMethod(_x4, _x5) {
  return _changePaymentMethod.apply(this, arguments);
}
/**
 * Get a user friendly action string
 * @method formatAction
 * @name Jobin.Payment.formatAction
 * @param {ParseObject} payment
 * @returns {string} Payment action formated
 */
function _changePaymentMethod() {
  _changePaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(payment, newPaymentMethod) {
    var result;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return Parse.Cloud.run("changePaymentMethod", {
            paymentId: payment.id,
            paymentMethod: newPaymentMethod,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context4.sent;
          if (!result) {
            _context4.next = 8;
            break;
          }
          return _context4.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          return _context4.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de cambiar el método de pago."
          });
        case 9:
          _context4.next = 15;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          console.error(_context4.t0);
          return _context4.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de cambiar el método de pago."
          });
        case 15:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  }));
  return _changePaymentMethod.apply(this, arguments);
}
export function formatAction(payment) {
  var action = payment.get("Action");
  switch (action) {
    case "pending":
      if (payment.get("RelatedTo")) return "Pago facturado";
      return "Pago pendiente";
    case "cancelled":
      return "Pago cancelado";
    case "devolucion":
      return "Pago devuelto";
    default:
      return "Pago realizado";
  }
}
/**
 * Get a user friendly action string
 * @method formatMethod
 * @name Jobin.Payment.formatMethod
 * @param {ParseObject} payment
 * @returns {string} Payment action formated
 */

export function formatMethod(payment) {
  var method = payment.get("Method");
  switch (method) {
    case "paycard":
      return "Tarjeta (Stripe)";
    case "tpv":
      return "Tarjeta (TPV)";
    case "cash":
      return "Metálico";
    case "transfer":
      return "Transferencia";
    case "invoice":
      return "Email";
    case "credit":
      return "Crédito";
    case "business":
      return "Finan. empr.";
    case "funding":
      return "Financiado";
    default:
      return method;
  }
}
/**
 * gets payments related to the provided business identifier
 * @method getBusinessPayments
 * @name Jobin.Payment.getBusinessPayments
 * @param {string} businessId
 * @param {string} monthYear
 * @returns {ParseObject} Payments
 */

export function getBusinessPayments(_x6, _x7) {
  return _getBusinessPayments.apply(this, arguments);
}
function _getBusinessPayments() {
  _getBusinessPayments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(businessId, monthYear) {
    var currentUser, Business, paymentsQuery, date, startDate, endDate;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context5.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context5.next = 28;
            break;
          }
          _context5.prev = 4;
          _context5.next = 7;
          return new Parse.Query("Business").get(businessId);
        case 7:
          Business = _context5.sent;
          if (!Business) {
            _context5.next = 19;
            break;
          }
          paymentsQuery = new Parse.Query("Payments");
          paymentsQuery.equalTo("Business", Business);
          if (monthYear) {
            date = new Date(monthYear.split("-")[1], monthYear.split("-")[0] - 1, 1);
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            paymentsQuery.greaterThan("createdAt", startDate);
            paymentsQuery.lessThan("createdAt", endDate);
          }
          _context5.next = 14;
          return paymentsQuery.find();
        case 14:
          _context5.t0 = _context5.sent;
          _context5.t1 = {
            payments: _context5.t0
          };
          return _context5.abrupt("return", {
            status: "ok",
            result: _context5.t1
          });
        case 19:
          return _context5.abrupt("return", {
            status: "error",
            result: "No hay ningún negocio con ese identificador."
          });
        case 20:
          _context5.next = 26;
          break;
        case 22:
          _context5.prev = 22;
          _context5.t2 = _context5["catch"](4);
          console.error(_context5.t2);
          return _context5.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información de los pagos."
          });
        case 26:
          _context5.next = 29;
          break;
        case 28:
          return _context5.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 29:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[4, 22]]);
  }));
  return _getBusinessPayments.apply(this, arguments);
}
export function getJobPaymentSummary(_x8) {
  return _getJobPaymentSummary.apply(this, arguments);
}
/**
 * Check the status of a stripe payment intent
 * @method confirmIntent
 * @name Jobin.Payment.confirmIntent
 * @param {string} stripeKey
 * @param {string} paymentIntent
 * @returns {string} status of the stripe payment intent
 */
function _getJobPaymentSummary() {
  _getJobPaymentSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(job) {
    var payments, summary, i, payment, name;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return new Parse.Query("Payments").equalTo("Job", job).find();
        case 2:
          payments = _context6.sent;
          summary = {
            pending: {
              total: 0
            },
            paid: {
              total: 0
            }
          };
          for (i = 0; i < payments.length; i++) {
            payment = payments[i];
            name = payment.get("Method");
            if (payment.get("Action") === "pending") {
              summary["pending"][name] = (summary["pending"][name] || 0) + payment.get("Price");
              summary["pending"]["total"] += payment.get("Price");
            } else {
              summary["paid"][name] = (summary["paid"][name] || 0) + payment.get("Price");
              summary["paid"]["total"] += payment.get("Price");
            }
          }
          return _context6.abrupt("return", summary);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getJobPaymentSummary.apply(this, arguments);
}
export function confirmIntent(_x9, _x10) {
  return _confirmIntent.apply(this, arguments);
}
function _confirmIntent() {
  _confirmIntent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(stripeKey, paymentIntent) {
    var Stripe, stripe, result;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          Stripe = require("stripe");
          stripe = new Stripe(stripeKey);
          _context7.prev = 2;
          _context7.next = 5;
          return stripe.paymentIntents.retrieve(paymentIntent);
        case 5:
          result = _context7.sent;
          return _context7.abrupt("return", {
            status: 'ok',
            result: result.status
          });
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](2);
          console.error(_context7.t0);
          return _context7.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al intentar actualizar el estado del pago"
          });
        case 13:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[2, 9]]);
  }));
  return _confirmIntent.apply(this, arguments);
}